/**
 * Flexible Learning model
 */
export class FlexibleLearning {
  constructor(
    public name: string,
    public slug_name: string,
    public icon: string,
    public description: string
  ) {}
}
